module.exports = __webpack_public_path__ + "9024d8231da6b99724eb81e3c62dd776.jpg";